import { Button, Color, Divider, Flex, NavListSeparator, Spacing, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { CustomerType } from '@features/contacts/enums/customerType'

import { ModalId } from '../../../../../../../../../../../../enums/modalId'
import { useInvoiceEditorForm } from '../../../../../../../../contexts/invoiceEditorFormContext'

const CustomerModalId = ModalId.CustomerModal
const UpgradeSubscriptionModalId = ModalId.UpgradeSubscriptionModal

interface InvoiceReceiverDropdownFooterProps {
  hasExceededContactsLimit: boolean
  isLoading: boolean
  onFooterButtonClick: (customerType: CustomerType) => void
}

export const InvoiceReceiverDropdownFooter = ({
  hasExceededContactsLimit,
  isLoading,
  onFooterButtonClick,
}: InvoiceReceiverDropdownFooterProps): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoiceEditor } = useInvoiceEditorForm()

  const { open: openCustomerModal } = useModal(CustomerModalId)
  const { open: openUpgradeModal } = useModal(UpgradeSubscriptionModalId)

  const openAdequateModal = useCallback(() => {
    if (hasExceededContactsLimit) {
      openUpgradeModal()
    } else {
      openCustomerModal()
    }
  }, [hasExceededContactsLimit, openCustomerModal, openUpgradeModal])

  const handleCreateCompanyCustomerButtonClick = useCallback(() => {
    onFooterButtonClick(CustomerType.Company)
    openAdequateModal()
    trackInvoiceEditor('Form - Customer - Create a company clicked')
  }, [onFooterButtonClick, openAdequateModal, trackInvoiceEditor])

  const handleCreateIndividualCustomerButtonClick = useCallback(() => {
    onFooterButtonClick(CustomerType.Individual)
    openAdequateModal()
    trackInvoiceEditor('Form - Customer - Create an individual clicked')
  }, [onFooterButtonClick, openAdequateModal, trackInvoiceEditor])

  return (
    <>
      <NavListSeparator />
      <Flex justifyContent="center" gap={Spacing.S8}>
        <Button
          disabled={isLoading}
          fullWidth
          icon="store"
          loading={isLoading}
          onClick={handleCreateCompanyCustomerButtonClick}
          variant="text"
        >
          {t('external_invoices.editor.form.field.receiver.create.company_customer.label')}
        </Button>
        <Divider direction="vertical" dividerColor={Color.Grey300} />
        <Button
          disabled={isLoading}
          fullWidth
          icon="userRound"
          loading={isLoading}
          onClick={handleCreateIndividualCustomerButtonClick}
          variant="text"
        >
          {t('external_invoices.editor.form.field.receiver.create.individual_customer.label')}
        </Button>
      </Flex>
    </>
  )
}
